import { gql } from '@eti/schema-types';

export const PAYMENT_DATA_QUERY = gql(/* GraphQL */ `
  query paymentDataOnPaymentPage {
    countries {
      label: name
      value: code
      phonePrefixes {
        id
        prefix
      }
    }
    cart {
      id
      state
      customerEmail
      customerPhone
      customerContactInfo {
        firstName
        lastName
        email
        phone {
          countryCallingCode
          numberWithoutCountryCode
        }
      }
      chargeCurrencyPriceFormat {
        currencySymbol
        currencyName
        decimalSymbol
        currencyExponent
        groupingSeparator
        pattern
      }
      hasPotentialForAdditionalTax
      priceInChargeCurrency {
        price {
          currency {
            code
          }
        }
      }
      products {
        name
        code
        productSummaryAlternativeName
        productId: id
        productSpecificTexts {
          ... on ProductSegmentAvailabilityTexts {
            __typename
            productSegmentAvailabilityTexts {
              arrivalAirport
              available
              boundType
              boundIndex
              departureAirport
              departureDateTime
              flightNumber
              segmentIndex
              extSystem
            }
          }
        }
        price {
          markup {
            value
            currency {
              code
            }
          }
          vat {
            value
            currency {
              code
            }
          }
          price {
            value
            currency {
              code
            }
          }
        }
        buySpecification {
          ... on BuySpecificationCartTraveler {
            travelerPrices {
              travelerId
              price {
                markup {
                  value
                  currency {
                    code
                  }
                }
                vat {
                  value
                  currency {
                    code
                  }
                }
                price {
                  value
                  currency {
                    code
                  }
                }
              }
            }
          }
          ... on BuySpecificationCartTravelerCabinBaggage {
            __typename
            travelerCabinBaggagePrices {
              travelerId
              ancillaryCarrierPriceBreakdowns {
                carrier {
                  code
                  name
                }
                providerPrice {
                  currency {
                    code
                  }
                  value
                }
              }
              price {
                markup {
                  value
                  currency {
                    code
                  }
                }
                vat {
                  value
                  currency {
                    code
                  }
                }
                price {
                  value
                  currency {
                    code
                  }
                }
              }
            }
          }
          ... on BuySpecificationCartTravelerBaggage {
            travelerBaggageTripPrices {
              travelerId
              maxWeight
              weightUnit
              pieces
              ancillaryCarrierPriceBreakdowns {
                carrier {
                  code
                  name
                }
                providerPrice {
                  currency {
                    name
                  }
                  value
                }
              }
              price {
                markup {
                  value
                  currency {
                    code
                  }
                }
                vat {
                  value
                  currency {
                    code
                  }
                }
                price {
                  value
                  currency {
                    code
                  }
                }
              }
            }
          }
          ... on BuySpecificationCartTravelerChoice {
            travelerChoicePrices {
              travelerId
              choice
              price {
                markup {
                  value
                  currency {
                    code
                  }
                }
                vat {
                  value
                  currency {
                    code
                  }
                }
                price {
                  value
                  currency {
                    code
                  }
                }
              }
            }
          }
          ... on BuySpecificationCartTravelerSeatMap {
            travelerSeatMapPrices {
              travelerId
              boundIndex
              segmentIndex
              seat
              price {
                markup {
                  value
                }
                price {
                  value
                }
              }
            }
            travelerSeatMapDetails {
              travelerId
              ancillaryCarrierPriceBreakdowns {
                carrier {
                  code
                  name
                }
                providerPrice {
                  value
                }
              }
              price {
                markup {
                  value
                }
                price {
                  value
                }
              }
            }
          }
        }
      }
      ancillaryBundles {
        id
        name
        selectedOption
        options {
          id
          name
          content {
            name
            included
            weight
            weightUnit
            pieces
            productTypeId
          }
          price {
            price {
              value
            }
          }
        }
      }
      trips {
        selectionKey
        tripCharacteristics
        includedExtraProducts {
          id
          texts {
            name
          }
        }
        checkedBaggageSummary {
          tripSummaries {
            baggageDetails {
              pieces
              weight
              weightUnit
            }
            baggageStatus
            travelerId
          }
        }
        cabinBaggageTripSummary {
          cabinBaggageTravelerDetails {
            cabinBaggageDetails {
              pieces
              weight
              weightUnit
            }
            cabinBaggageStatus
            travelerId
          }
        }
        personalItemTripSummary {
          personalItemTravelerDetails {
            personalItemStatus
            travelerId
            personalItemDetails {
              size3d {
                height
                length
                width
              }
            }
          }
        }
        includedCabinBaggage {
          includedPersonalItem
        }
        bounds {
          boundId: id
          includedCheckedBaggage {
            ...IncludedCheckedBaggage
          }
          includedCabinBaggage {
            ...IncludedCabinBaggage
          }
          segments {
            ... on TripSegment {
              __typename
              aircraftType
              arrivedAt
              brandedFareInformation {
                name
                features {
                  availability
                  code
                  group
                  name
                }
              }
              cabinClassName
              includedCheckedBaggage {
                ...IncludedCheckedBaggage
              }
              includedCabinBaggage {
                ...IncludedCabinBaggage
              }
              departuredAt
              segmentDetails {
                numberOfSeatsLeft
              }
              destination {
                code
                name
                cityCode
                cityName
              }
              duration
              equipmentCode
              flightNumber
              segmentId: id
              lccSupplier
              marketingCarrier {
                code
                name
                conditions {
                  url
                }
              }
              ticketingCarrier {
                code
              }
              numberOfTechnicalStops
              operatingCarrier {
                code
                name
              }
              operatingInformation
              origin {
                code
                name
                cityCode
                cityName
              }
              technicalStops {
                arrivalAt
                departureAt
                duration
                location {
                  code
                  name
                  cityName
                  cityCode
                }
              }
            }
            ... on EventSegment {
              __typename
              duration
              types
              segmentId: id
            }
          }
        }
        travelers {
          ageType
          firstName
          id
          lastName
          name
        }
        travelerPrices {
          carrierPriceBreakdowns {
            carrier {
              name
              code
            }
            providerPrice {
              value
              currency {
                code
              }
            }
            vat {
              value
              currency {
                code
              }
            }
            taxesAndFees {
              category
              taxes {
                code
                title
                amount {
                  value
                  currency {
                    code
                  }
                }
              }
            }
          }
          price {
            price {
              value
            }
            vat {
              value
            }
            markup {
              value
            }
          }
          taxesAndFees {
            category
            taxes {
              code
              title
              amount {
                value
              }
            }
          }
          travelerId
        }
        changes {
          ... on TripPriceChange {
            priceDiff {
              price {
                value
                currency {
                  code
                }
              }
            }
            priceOld {
              price {
                value
                currency {
                  code
                }
              }
            }
            priceNew {
              price {
                value
                currency {
                  code
                }
              }
            }
          }
          ... on TripScheduleChange {
            segmentId
            departureTimeNew
            departureTimeOld
            arrivalTimeNew
            arrivalTimeOld
          }
        }
        fareRules {
          header
          content
        }
        type
        systems
      }
      discountPrice {
        price {
          value
        }
      }
      serviceFee {
        currency {
          code
          exponent
          name
        }
        value
      }
      subtotalPrice {
        price {
          value
        }
      }
    }

    paymentData {
      transactionId
      cadillac {
        siteKey
        url
        filename
      }
      isPanAndDoBDisabled: disablePanAndDoB
      availablePaymentMethods {
        paymentServiceProvider
        type
        ... on CardPaymentMethod {
          binVerificationType
          paymentFlow {
            type
            ... on ClientSideEncryptionPaymentFlow {
              publicKey
              generationTime
            }
            ... on TokenizationPaymentFlow {
              tokenizationUrl
            }
          }
          thunderbird {
            enabled
            publicKey
          }
          creditCards {
            code
            name
            id
            price {
              value
              currency {
                name
                exponent
              }
            }
            serviceFee {
              value
              currency {
                name
                exponent
              }
            }
          }
          potentialChargeInDifferentCurrency
          potentialChargeInCurrencies
        }
        ... on BankPaymentMethod {
          banks {
            id
            name
            code
            price {
              value
              currency {
                code
                name
                exponent
              }
            }
            serviceFee {
              value
              currency {
                name
                exponent
              }
            }
          }
          texts {
            descriptionText
          }
        }
        ... on WalletPaymentMethod {
          wallets {
            id
            code
            name
            price {
              value
            }
            serviceFee {
              value
            }
            additionalData {
              ... on ApplePayAdditionalData {
                countryCode
                currencyCode
                merchantIdentifier
                merchantCapabilities
                supportedNetworks
                label
                totalAmount
              }
              ... on GooglePayAdditionalData {
                code
                totalAmount
                currencyCode
                countryCode
                merchantId
                merchantCapabilities
                gateway
                gatewayMerchantId
                allowedCardNetworks
              }
            }
          }
        }
      }
    }
    selectedTrip {
      dynamicBookingFlow {
        stepIndicators {
          stepNumber
          name
          completed
        }
      }
    }
  }
`);

export const PAYMENT_CART_QUERY = gql(/* GraphQL */ `
  query Cart($selectedPaymentMethod: PaymentMethodInput) {
    cart(selectedPaymentMethod: $selectedPaymentMethod) {
      chargeCurrencyPriceFormat {
        currencySymbol
        currencyName
        decimalSymbol
        currencyExponent
        groupingSeparator
        pattern
      }
      priceInChargeCurrency {
        markup {
          value
        }
        price {
          value
          currency {
            code
            exponent
          }
        }
        vat {
          value
        }
      }
      price {
        markup {
          value
        }
        price {
          value
        }
        vat {
          value
        }
      }
      trips {
        id
        travelers {
          ageType
          id
        }
        travelerPrices {
          id
          carrierPriceBreakdowns {
            carrier {
              name
              code
            }
            providerPrice {
              value
              currency {
                code
              }
            }
            vat {
              value
              currency {
                code
              }
            }
            taxesAndFees {
              category
              taxes {
                code
                title
                amount {
                  value
                  currency {
                    code
                  }
                }
              }
            }
          }
          price {
            markup {
              value
            }
            price {
              value
            }
            vat {
              value
            }
          }
          taxesAndFees {
            category
            taxes {
              code
              title
              amount {
                value
              }
            }
          }
          travelerId
        }
        voucherAmount {
          value
        }
      }
    }
  }
`);

export const PAYMENT_LINK_DATA_QUERY = gql(/* GraphQL */ `
  query paymentData($cartId: Long) {
    countries {
      label: name
      value: code
    }
    paymentData(cartId: $cartId) {
      transactionId
      cadillac {
        siteKey
        url
        filename
      }
      isPanAndDoBDisabled: disablePanAndDoB
      availablePaymentMethods {
        paymentServiceProvider
        type
        ... on CardPaymentMethod {
          binVerificationType
          paymentFlow {
            type
            ... on ClientSideEncryptionPaymentFlow {
              publicKey
              generationTime
            }
            ... on TokenizationPaymentFlow {
              tokenizationUrl
            }
          }
          thunderbird {
            enabled
            publicKey
          }
          creditCards {
            code
            name
            id
            price {
              value
              currency {
                name
                exponent
              }
            }
            serviceFee {
              value
              currency {
                name
                exponent
              }
            }
          }
          potentialChargeInDifferentCurrency
        }
        ... on BankPaymentMethod {
          banks {
            id
            name
            code
            price {
              value
              currency {
                code
                name
                exponent
              }
            }
            serviceFee {
              value
              currency {
                name
                exponent
              }
            }
          }
          texts {
            descriptionText
          }
        }
        ... on WalletPaymentMethod {
          wallets {
            id
            code
            name
            price {
              value
            }
            serviceFee {
              value
            }
            additionalData {
              ... on ApplePayAdditionalData {
                countryCode
                currencyCode
                merchantIdentifier
                merchantCapabilities
                supportedNetworks
                label
                totalAmount
              }
              ... on GooglePayAdditionalData {
                code
                totalAmount
                currencyCode
                countryCode
                merchantId
                merchantCapabilities
                gateway
                gatewayMerchantId
                allowedCardNetworks
              }
            }
          }
        }
      }
    }
  }
`);

export const PAYMENT_LINK_CART_QUERY = gql(/* GraphQL */ `
  query paymentLinkCart($crypticCode: String) {
    paymentLinkCart(crypticCode: $crypticCode) {
      cartType
      id
      priceInChargeCurrency {
        markup {
          value
          currency {
            code
            exponent
            name
          }
        }
        price {
          value
          currency {
            code
            exponent
            name
          }
        }
        vat {
          value
        }
      }
      chargeCurrencyPriceFormat {
        currencySymbol
        currencyName
        decimalSymbol
        currencyExponent
        groupingSeparator
        pattern
      }
      price {
        price {
          value
          currency {
            code
          }
        }
        vat {
          currency {
            code
          }
          value
        }
        markup {
          currency {
            code
          }
          value
        }
      }
      products {
        travelers {
          firstName
          lastName
        }
        price {
          price {
            value
            currency {
              code
            }
          }
          vat {
            value
            currency {
              code
            }
          }
          markup {
            value
            currency {
              code
            }
          }
        }
        productId: id
        name
        productSummaryAlternativeName
        text
        code
      }
    }
  }
`);

export const FETCH_INSTALMENT_OPTIONS_QUERY = gql(/* GraphQL */ `
  query instalmentOptions($bin: String!, $orderAmountX100: String) {
    instalmentOptions(bin: $bin, orderAmountX100: $orderAmountX100) {
      paymentInstalmentOptions {
        baseCostPerInstalment
        feePerInstalment
        installmentOptionId
        isCostPaidByCustomer
        numberOfInstalments
        ratePercentage
        totalCostAfterFees
        totalCostPerInstalment
        totalFees
      }
      shouldAddInstallmentFeeInTotalAmount
    }
  }
`);

export const PAYMENT_METHOD_ISSUER_OPTIONS = gql(/* GraphQL */ `
  query paymentMethodIssuerOptionsQuery($orderAmountX100: String!, $walletPaymentMethod: String!) {
    paymentMethodIssuerOptions(
      orderAmountX100: $orderAmountX100
      walletPaymentMethod: $walletPaymentMethod
    ) {
      id
      name
    }
  }
`);
